import { PaginationRequestType } from '@/entity/common/pagination.types';

export function prepareFormData(data?: PaginationRequestType):any {
    const formData = new FormData()
    try {
        if (data) {
            if (data.skip) {
                formData.append('skip', data.skip.toString());
            } else formData.delete('skip');
            if (data.limit || data.limit === 0) {
                formData.append('limit', data.limit.toString());
            } else formData.delete('limit');
            if (data.by) {
                formData.append('by', data.by.toString());
            } else formData.delete('by');
            if (data.sort) {
                formData.append('sort', data.sort.toString());
            } else formData.delete('sort');
            if (data.options) {
                Object.keys(data.options).forEach(field => formData.append('options[' + field + ']', data.options[field].toString()));
            } else formData.delete('options');
            if (data.filter) {
                Object.keys(data.filter).forEach(field => {
                    if(data.filter[field]) {
                        formData.append('filter[' + field + ']', typeof data.filter[field] === 'string' ? data.filter[field] :  data.filter[field].toString())
                    }
                });
            } else formData.delete('filter');
        }
    } catch(e) {
        console.warn('prepareFormData - error');
        console.error(e.message)
    }
    return formData
}